import React from 'react'
import { useAppStore } from '@/hooks/useAppStore'
import type { Screen } from '@/types'

interface TopbarProps {
  center?: React.ReactNode
  backTo?: Screen
  backLabel?: string
}

export function Topbar({ center, backTo, backLabel = '← Back' }: TopbarProps) {
  const setScreen = useAppStore((s) => s.setScreen)
  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 20px', background: 'var(--forest)',
      borderBottom: '1px solid rgba(201,151,58,0.2)',
    }}>
      <div>
        <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 16, letterSpacing: '0.14em', color: 'var(--candle2)', textTransform: 'uppercase' }}>
          Sanctum
        </div>
        <div style={{ fontFamily: 'var(--sans)', fontSize: 9, color: 'rgba(201,151,58,0.6)', letterSpacing: '0.1em', marginTop: -2 }}>
          by Imaginarium
        </div>
      </div>
      {center && (
        <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 10, color: 'var(--candle)', letterSpacing: '0.1em', background: 'rgba(201,151,58,0.12)', padding: '4px 12px', border: '1px solid rgba(201,151,58,0.25)' }}>
          {center}
        </div>
      )}
      {backTo ? (
        <button onClick={() => setScreen(backTo)} style={{
          fontFamily: 'var(--serif-caps)', fontSize: 10, letterSpacing: '0.08em', color: 'var(--candle)',
          background: 'transparent', border: '1px solid rgba(201,151,58,0.25)', padding: '5px 12px', cursor: 'pointer',
        }}>{backLabel}</button>
      ) : <div style={{ width: 60 }} />}
    </header>
  )
}
